import {PlayerStatsDto} from "sandy-shared/dist/dtos/player.dto";
import {PlayerWithSideInfo} from "sandy-shared/dist/types/player-info.type";
import {AttackOriginLocation, AttackOutLocation, AttackType, AttackDestinationLocation, PassType} from "sandy-shared/dist/types/attack-info.type";
import {ServeInPlayLocation} from "sandy-shared/dist/types/servce-info.type";
import { PartnershipDto } from "sandy-shared/dist/dtos/partnership.dto";

export interface EphemeralPointState {
  serveInPlayLocation?: ServeInPlayLocation;
  passType?: PassType;
  attackDestinationLocation?: AttackDestinationLocation;
  attackOriginLocation?: AttackOriginLocation;
  attackOutLocation?: AttackOutLocation;
  attackType?: AttackType;
  currentPointState: CurrentPointState;
}

export type PlayerStatsWithId = PlayerStatsDto & { playerId: number };
export type PartnershipWithState = Omit<PartnershipDto, 'playerOne' | 'playerTwo'> & { playerOne: PlayerWithSideInfo, playerTwo: PlayerWithSideInfo, score: number };

export const CurrentPointState = {
  PendingServe: 'PendingServe',
  ServeInPlay: 'ServeInPlay',
  PassGraded: 'PassGraded',
  AttackTypeSelected: 'AttackTypeSelected',
  AttackOriginSelected: 'AttackOriginSelected',
  AttackInPlay: 'AttackInPlay',
  DigTransition: 'DigTransition',
  BlockTransition: 'BlockTransition',
  FreeBallTransition: 'FreeBallTransition',
  Fault: 'Fault' // This isn't really a transition, but it matches our pattern of all transitions allowing the user to select a winning partnership
} as const
export type CurrentPointState = typeof CurrentPointState[keyof typeof CurrentPointState]